import Button from '../../../components/CustomButtons/ButtonTS';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import Loading from '../Loading/Loading';
import React from 'react';
import { INode, ISystem } from '../../helpers/interfaces';
import { CSSProperties } from '@material-ui/styles';
import Tooltip from "@material-ui/core/Tooltip";

interface IDownloadIconProps {
	show: boolean;
	node: INode;
	system: ISystem;
	disabledDownloadIcons: number[];
	showExportCard: (node: INode, system: ISystem) => void;
}

const loaderWrapperStyle: CSSProperties = {
	marginTop: '10px',
	marginBottom: '10px',
	marginLeft: '2px',
	paddingTop: '5px',
	width: '41px',
};

export const DownloadIcon = (props: IDownloadIconProps) => {
	const { show, showExportCard, node, disabledDownloadIcons, system } = props;
	const disabledIcons = [...disabledDownloadIcons];
	if (!show) {
		return null;
	}
	return (
		<>
			{disabledIcons.indexOf(node.id) >= 0 ? (
				<div style={loaderWrapperStyle}>
					<Loading transform={1} height={17} width={40} color='gray' />
				</div>
			) : (
                <Tooltip title="Export measurements">
                    <div>
                        <Button color='info' simple justIcon onClick={() => showExportCard(node, system)} data-testid='downloadIcon'>
                            <CloudDownloadIcon />
                        </Button>
                    </div>
                </Tooltip>
			)}
		</>
	);
};

export default DownloadIcon;
